import { actionsToArray } from '@noven-prime/lattice-core';
import { formSubmissionsActions } from './actions.js';
/**
 * Form Submissions Capability Manifest
 *
 * The portal-side half of the contact form: reading, triaging and deleting
 * inquiries in the private `submissions` container, plus the notification
 * settings the /api/contact function reads when it sends the alert.
 */
export const formSubmissionsManifest = {
    id: 'form-submissions',
    name: 'Form Submissions',
    description: 'Read and triage contact-form inquiries, and configure notifications',
    version: '1.0.0',
    surfaces: {
        allowed: '*',
    },
    experiences: {
        allowed: '*',
    },
    actions: actionsToArray(formSubmissionsActions),
    features: [
        {
            id: 'inquiry-inbox',
            name: 'Inquiry Inbox',
            description: 'View, triage and delete contact-form inquiries',
            actions: actionsToArray(formSubmissionsActions),
        },
    ],
};
//# sourceMappingURL=manifest.js.map